
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { column } from "@/assets/types/common";
import { Request } from "@/api/request";

export default defineComponent({
    name: "Jurisdiction",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["角色管理"]);
        let loading = ref(false),
            Route = useRoute(),
            Router = useRouter(),
            form = ref({ role_name: "" }),
            formRef = ref(null),
            id: any = null,
            store_id: any = null,
            pcList = ref([]),
            h5List = ref([]);
        let getCheckboxRoute = () => {
                let roleList: any = [];
                pcList.value.forEach((parent: any) => {
					if(parent.type == 1){
						roleList.push(parent.id);
					}
                    parent.children.map((children: any) => {
                        if(children.type == 1){
							roleList.push(children.id);
                        }
						children.grandson.map((grandson: any) => {
							if(grandson.type == 1){
								roleList.push(grandson.id);
							}
						})
                    })
                });
                h5List.value.forEach((parent: any) => {
					if(parent.type == 1){
						roleList.push(parent.id);
					}
                    parent.children.map((children: any) => {
                        if(children.type == 1){
							roleList.push(children.id);
                        }
						children.grandson.map((grandson: any) => {
							if(grandson.type == 1){
								roleList.push(grandson.id);
							}
						})
                    })
                });
				console.log(roleList)
                return roleList;
            },
			// 全选/取消全选（二级+三级）
            selectAllChildren = (parentId:number) => {
				// 遍历PC端权限 一级
                pcList.value.forEach((parent: any) => {
				  if(parent.id == parentId){
					// 遍历二级
                    parent.children.map((children: any) => {
						children.type = !parent.type;
						// 遍历三级
						children.grandson.map((grandson: any) => {
							grandson.type = !parent.type;
						})
					})
				  }
                });
				// 遍历手机端权限 一级
                h5List.value.forEach((parent: any) => {
				  if(parent.id == parentId){
					// 遍历二级
                    parent.children.map((children: any) => {
						children.type = !parent.type;
						// 遍历三级
						children.grandson.map((grandson: any) => {
							grandson.type = !parent.type;
						})
					})
				  }
                });
			},
			// 全选/取消全选（三级）
            selectAllGrandson = (childrenId:number) => {
				// 遍历PC端权限 一级
                pcList.value.forEach((parent: any) => {
					// 遍历二级
                    parent.children.map((children: any) => {
						if(children.id == childrenId){
							// 遍历三级
							children.grandson.map((grandson: any) => {
								grandson.type = !children.type;
							})
						}
					})
                });
				// 遍历手机端权限 一级
                h5List.value.forEach((parent: any) => {
					// 遍历二级
                    parent.children.map((children: any) => {
						if(children.id == childrenId){
							// 遍历三级
							children.grandson.map((grandson: any) => {
								grandson.type = !children.type;
							})
						}
					})
                });
			},
            onSubmit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        let data: any = {
                                ...form.value,
                                store_id:store_id,
                                privilege_id: getCheckboxRoute().join(",")
                            },
                            url = "adminapi/Role/create";
                            console.log(data)
                        if (id > 0) {
                            data = {
                                ...data,
                                role_id:id,
                                store_id:store_id,
                            };
                            url = "adminapi/Role/edit";
                        }
                        Request.axiosInstance({
                            url,
                            data,
                        }).then((res) => {
                            if (res.status == 202) {
                                Router.back();
                            }
                        });
                    }
                });
            };

        onMounted(() => {
            loading.value = true;
            let data = {},
                query = Object.keys(Route.query).length;
            if (query > 0) {
                id = Route.query.id;
                store_id = Route.query.store_id;
                data = {
                    role_id:id,
                    store_id:store_id,
                };
            }
			Request.axiosInstance({
				url: "adminapi/Role/info",
				data,
			}).then((res: any) => {
				loading.value = false;
				if (res.status == 200) {
					pcList.value = res.content.pc_list;
					h5List.value = res.content.h5_list;
					query > 0 && (form.value.role_name = res.content.role_name);
				}
			});
            // getTableData();
        });

        return {
            loading,
            Router,
            form,
            formRef,
            onSubmit,
            pcList,
            h5List,
            selectAllChildren,
            selectAllGrandson,
        };
    },
});
